<template>
    <DModal
        :show="showModal"
        :title="__('customers.manage_clusters.move_cluster_and_contracts')"
        is-confirm
        is-big
        :is-awaiting-validation="true"
        :disabled-action="disabledAction"
        :confirm-button-text="__('customers.manage_clusters.execute')"
        @confirm="execute"
        @close="onClose"
    >
        <SearchCustomerForm
            :label="__('customers.manage_clusters.new_customer')"
            @selectCustomer="onSelectCustomer"
        />
        <DCard padding>
            <DFieldLoading
                v-if="form.processing"
                is-loading
                is-big
                class="my-4 d-flex justify-content-center"
            />
            <DTable
                v-else
                :items="cluster.contracts"
                :fields="fields"
            >
                <template #id="{ item }">
                    <td>
                        <span :style="{ paddingLeft: `${item.depth * 20}px` }">
                            <span v-if="item.depth > 0">↳ </span>{{ item.id }}
                        </span>
                    </td>
                </template>
                <template #parent_id="{ item }">
                    <td>
                        {{ item.parent_id }}
                    </td>
                </template>
            </DTable>
        </DCard>
        <template #actions>
            <DAlert
                v-if="hasErrors"
                color="danger"
                class="m-0 p-2 w-100"
            >
                <div
                    v-for="(message, key) in form.errors"
                    :key="key"
                >
                    {{ message }}
                </div>
            </DAlert>
        </template>
    </DModal>
</template>

<script setup>
import { computed, ref } from 'vue'
import { useForm, usePage } from '@inertiajs/vue3'
import { __ } from '~@/Composables/translation'
import { route } from '~@/Composables/route'
import SearchCustomerForm from '~@/Components/Customers/Customers/SearchCustomerForm'
import DFieldLoading from '~@/Components/Common/DFieldLoading'

const props = defineProps({
    showModal: {
        type: Boolean,
        default: false
    },
    cluster: {
        type: Object,
        default: () => {
            return { id: null, is_dedicated: false, contracts: [] }
        }
    }
})

const emit = defineEmits(['close-modal'])

const fields = [
    { key: 'id', label: __('customers.manage_clusters.contract_id') },
    { key: 'external_id', label: __('customers.manage_clusters.external_id') },
    { key: 'parent_id', label: __('customers.manage_clusters.parent_contract_id') }
]

const selectedCustomer = ref(null)

const disabledAction = computed(() => {
    return selectedCustomer.value === null
})

const onSelectCustomer = (customer) => {
    selectedCustomer.value = typeof customer === 'undefined' ? null : customer
}

const form = useForm({
    cluster_id: null,
    brand: null,
    new_customer_id: null,
    contract_ids: []
})

const hasErrors = computed(() => {
    return Object.keys(form.errors).length > 0
})

const execute = () => {
    form.new_customer_id = selectedCustomer.value.id
    form.contract_ids = props.cluster.contracts.map((contract) => contract.id)

    const routeName = props.cluster.is_dedicated
        ? 'customers.customers.manage-clusters.dedicated-transfer'
        : 'customers.customers.manage-clusters.transfer'

    if (props.cluster.is_dedicated === false) {
        form.cluster_id = props.cluster.id
        form.brand = props.cluster.brand ?? null
    }

    form.post(route(routeName, { customer: usePage().props.customer.id }), {
        onSuccess: () => {
            emit('close-modal')
        }
    })
}

const onClose = () => {
    form.clearErrors()
    emit('close-modal')
}
</script>
